/* istanbul ignore file */
import { CREATE_PURCHASE_ORDER } from 'domain/finance/purchaseOrder/usePurchaseOrderService';
import { usePurchaseOrderUrl } from 'domain/finance/purchaseOrder/shared/usePurchaseOrderRouting';
import { useAuthorization } from 'framework/authorization';
import { useFieldHelper } from 'framework/ui/field';
import { LinkButton } from 'framework/ui/ui-builder';

const CopyPurchaseOrderButton = (props: { source?: string }) => {
  const { getCopyEntityUrl } = usePurchaseOrderUrl();
  const { getValue: getId } = useFieldHelper(props);
  const id = getId();
  const { isGranted } = useAuthorization();

  return isGranted(CREATE_PURCHASE_ORDER) ? (
    <LinkButton variant="outlined" {...props} url={getCopyEntityUrl(id)}>
      Copy
    </LinkButton>
  ) : null;
};

export default CopyPurchaseOrderButton;
